//#region src/helpers/get-talkative-elements.ts
const getTalkativeEngageElement = () => document.getElementById("talkative-engage");
const getTalkativeApp = () => getTalkativeEngageElement()?.shadowRoot?.querySelector("#app") ?? null;
const getOpenWidgetButton = () => getTalkativeApp()?.querySelector(".fixed")?.querySelector("button") ?? null;
const openTalkativeUI = () => {
	window.talkativeApi.ui.show();
};

//#endregion
export { getOpenWidgetButton, getTalkativeEngageElement, openTalkativeUI };